export enum AccessPermission {
    AppraisalRead = 'appraisal:read',
    AppraisalWrite = 'appraisal:write',
    AssignmentRead = 'assignment:read',
    AssignmentWrite = 'assignment:write',
    ChemicalLogRead = 'chemical_log:read',
    ChemicalLogWrite = 'chemical_log:write',
    CompanyEventRead = 'company_event:read',
    CompanyEventWrite = 'company_event:write',
    ContingencyPlanRead = 'contingency_plan:read',
    ContingencyPlanWrite = 'contingency_plan:write',
    ContractModalGeneralInfoRead = 'contract_modal_general_info:read',
    ContractModalGeneralInfoWrite = 'contract_modal_general_info:write',
    ContractModalHoursRead = 'contract_modal_hours:read',
    ContractModalHoursWrite = 'contract_modal_hours:write',
    ContractModalPayrollRead = 'contract_modal_payroll:read',
    ContractModalPayrollWrite = 'contract_modal_payroll:write',
    CrewChangeEventRead = 'crew_change_event:read',
    CrewChangeEventWrite = 'crew_change_event:write',
    CrewLeaveOverviewRead = 'crew_leave_overview:read',
    CrewModalCommunicationRead = 'crew_modal_communication:read',
    CrewModalCommunicationWrite = 'crew_modal_communication:write',
    CrewModalCompetencyRead = 'crew_modal_competency:read',
    CrewModalCompetencyWrite = 'crew_modal_competency:write',
    CrewModalDayBalanceRead = 'crew_modal_day_balance:read',
    CrewModalDayBalanceWrite = 'crew_modal_day_balance:write',
    CrewModalDocumentsContractRead = 'crew_modal_documents_contract:read',
    CrewModalDocumentsContractWrite = 'crew_modal_documents_contract:write',
    CrewModalDocumentsGeneralRead = 'crew_modal_documents_general:read',
    CrewModalDocumentsGeneralWrite = 'crew_modal_documents_general:write',
    CrewModalDocumentsHealthRead = 'crew_modal_documents_health:read',
    CrewModalDocumentsHealthWrite = 'crew_modal_documents_health:write',
    CrewModalDocumentsInternalRead = 'crew_modal_documents_internal:read',
    CrewModalDocumentsInternalWrite = 'crew_modal_documents_internal:write',
    CrewModalDocumentsRead = 'crew_modal_documents:read',
    CrewModalDocumentsTravelRead = 'crew_modal_documents_travel:read',
    CrewModalDocumentsTravelWrite = 'crew_modal_documents_travel:write',
    CrewModalDocumentsWrite = 'crew_modal_documents:write',
    CrewModalEmploymentRead = 'crew_modal_employment:read',
    CrewModalEmploymentWrite = 'crew_modal_employment:write',
    CrewModalGeneralInfoNotesRead = 'crew_modal_general_info_notes:read',
    CrewModalGeneralInfoNotesWrite = 'crew_modal_general_info_notes:write',
    CrewModalGeneralInfoRead = 'crew_modal_general_info:read',
    CrewModalGeneralInfoWrite = 'crew_modal_general_info:write',
    CrewModalInAdvanceAndLotRead = 'crew_modal_in_advance_and_lot:read',
    CrewModalInAdvanceAndLotWrite = 'crew_modal_in_advance_and_lot:write',
    CrewModalMiscRead = 'crew_modal_misc:read',
    CrewModalMiscWrite = 'crew_modal_misc:write',
    CrewModalPersonalProtectiveEquipmentRead = 'crew_modal_personal_protective_equipment:read',
    CrewModalPersonalProtectiveEquipmentWrite = 'crew_modal_personal_protective_equipment:write',
    CrewModalSailingHistoryRead = 'crew_modal_sailing_history:read',
    CrewModalSailingHistoryWrite = 'crew_modal_sailing_history:write',
    CrewModalWalletRead = 'crew_modal_wallet:read',
    CrewModalWalletWrite = 'crew_modal_wallet:write',
    CrewRead = 'crew:read',
    CrewWrite = 'crew:write',
    DeviationRead = 'deviation:read',
    DeviationWrite = 'deviation:write',
    InsightRead = 'insight:read',
    MaintenanceSystemRead = 'maintenance_system:read',
    MaintenanceSystemWrite = 'maintenance_system:write',
    OperationVesselRead = 'operations_vessels:read',
    OperationVesselWrite = 'operations_vessels:write',
    OperationsActivitiesCharterRead = 'operations_activities_charter:read',
    OperationsActivitiesCharterWrite = 'operations_activities_charter:write',
    OperationsActivitiesOtherRead = 'operations_activities_other:read',
    OperationsActivitiesOtherWrite = 'operations_activities_other:write',
    OperationsActivitiesRead = 'operations_activities:read',
    OperationsActivitiesScheduledRead = 'operations_activities_scheduled:read',
    OperationsActivitiesScheduledWrite = 'operations_activities_scheduled:write',
    OperationsActivitiesWrite = 'operations_activities:write',
    PayrollAdminAccountingExportRead = 'payroll_admin_accounting_export:read',
    PayrollAdminAccountingExportWrite = 'payroll_admin_accounting_export:write',
    PayrollAdminApproveRead = 'payroll_admin_approve:read',
    PayrollAdminApproveWrite = 'payroll_admin_approve:write',
    PayrollAdminEarningsAndDeductionsRead = 'payroll_admin_earnings_and_deductions:read',
    PayrollAdminEarningsAndDeductionsWrite = 'payroll_admin_earnings_and_deductions:write',
    PayrollAdminPaymentExportRead = 'payroll_admin_payment_export:read',
    PayrollAdminPaymentExportWrite = 'payroll_admin_payment_export:write',
    PayrollAdminPayoutRead = 'payroll_admin_payout:read',
    PayrollAdminPayoutWrite = 'payroll_admin_payout:write',
    PayrollAdminRead = 'payroll_admin:read',
    PayrollAdminWrite = 'payroll_admin:write',
    RiskAssessmentRead = 'risk_assessment:read',
    RiskAssessmentWrite = 'risk_assessment:write',
    RotationRead = 'rotation:read',
    RotationWrite = 'rotation:write',
    RoutineRead = 'routine:read',
    RoutineWrite = 'routine:write',
    SafeJobAnalysisRead = 'safe_job_analysis:read',
    SafeJobAnalysisWrite = 'safe_job_analysis:write',
    SafetyManagementSystemArticleRead = 'safety_management_system_article:read',
    SafetyManagementSystemArticleWrite = 'safety_management_system_article:write',
    SafetyManagementSystemRead = 'safety_management_system:read',
    SafetyManagementSystemWrite = 'safety_management_system:write',
    SafetyPosterRead = 'safety_poster:read',
    SafetyPosterWrite = 'safety_poster:write',
    SafetyProcedureRead = 'safety_procedure:read',
    SafetyProcedureWrite = 'safety_procedure:write',
    SettingsRead = 'settings:read',
    SettingsWrite = 'settings:write',
    TalentAndPlacementRead = 'talent_and_placement:read',
    TalentAndPlacementWrite = 'talent_and_placement:write',
    VesselCertificatesRead = 'vessel_certificates:read',
    VesselCertificatesWrite = 'vessel_certificates:write',
    VesselDocumentsRead = 'vessel_documents:read',
    VesselDocumentsWrite = 'vessel_documents:write',
    VesselGeneralInfoRead = 'vessel_general_info:read',
    VesselGeneralInfoWrite = 'vessel_general_info:write',
    VesselLotRead = 'vessel_lot:read',
    VesselLotWrite = 'vessel_lot:write',
    VesselManningRead = 'vessel_manning:read',
    VesselManningWrite = 'vessel_manning:write',
    VesselPayrollRead = 'vessel_payroll:read',
    VesselPayrollWrite = 'vessel_payroll:write',
    VesselPermissionRead = 'vessel_permissions:read',
    VesselPermissionWrite = 'vessel_permissions:write',
    VesselsRead = 'vessels:read',
    VesselsWrite = 'vessels:write',
    VesselRequirementsRead = 'vessel_requirements:read',
    VesselRequirementsWrite = 'vessel_requirements:write',
    WorkingHoursModalRead = 'working_hours_modal:read',
    WorkingHoursModalWrite = 'working_hours_modal:write',
}
